(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // The drawer pushes the page down rather than covering it, so the customer
  // never loses their place. It must close on every route out of it: Escape,
  // and resizing past the breakpoint where the full nav reappears.
  (function () {
    const btn = document.querySelector('.hdr__menu');
    const panel = document.getElementById('hdr-drawer');
    if (!btn || !panel) return;

    const setOpen = (open) => {
      btn.setAttribute('aria-expanded', String(open));
      panel.hidden = !open;
    };

    btn.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') === 'true';
      setOpen(!open);
      if (!open) {
        const first = panel.querySelector('a');
        if (first) first.focus();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || panel.hidden) return;
      setOpen(false);
      btn.focus();
    });

    // Above the breakpoint the full nav is visible, so an open drawer would
    // duplicate it.
    const wide = window.matchMedia('(min-width: 800px)');
    wide.addEventListener('change', (e) => { if (e.matches) setOpen(false); });
  })();

  } catch(e) { console.error(e); }
})();
})();
